export default __webpack_public_path__ + "static/cruiselines-carnival-activities-1-ae14486dc899147d36c51117533f5c45.jpg";